import { render } from "./VuetifyEmailConfirmInput.vue?vue&type=template&id=b4c221e8&scoped=true"
import script from "./VuetifyEmailConfirmInput.vue?vue&type=script&lang=js"
export * from "./VuetifyEmailConfirmInput.vue?vue&type=script&lang=js"

import "./VuetifyEmailConfirmInput.vue?vue&type=style&index=0&id=b4c221e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4c221e8"]])

export default __exports__